import React, { Suspense, useState } from 'react';
import { useNavigate } from 'react-router-dom';

import SearchIcon from '@mui/icons-material/Search';
import CheckIcon from '@mui/icons-material/Check';
import ActionMenu from '../../../../components/ui/materialui/actionMenu';
import { DatosTotalesDto } from '../models/resumenesTotales';
import ConfirmationModal from '../../../../components/ui/materialui/confirmationModal';
import { useLoader } from '../../../../hooks/useLoader';
import { aprobarAsientosContables } from '../services/serviceValidadorAsientosContables';
import { useValidadorAsientosContablesContext } from '../../../../context/validadorAsientosContablesContext';
import { useToast } from '../../../../hooks/useToast';
import { getCurrentUsername } from '../../../../services/userRolesService';

interface IProps {
  datoTotal: DatosTotalesDto
}

const AccionesAnalizador: React.FC<IProps> = ({ datoTotal }) => {
  const navigate = useNavigate();
  const { addToast } = useToast();
  const { showLoader, hideLoader } = useLoader();
  const { formFilters, incrementReloadFlag } = useValidadorAsientosContablesContext();
  const [modalConfirmacion, setModalConfirmacion] = useState({
    show: false,
    title: '',
    message: '',
    metodo: () => {},
  });

  const actions = [];
  const { key, credito, debito } = datoTotal;
  const debitoFixed = parseInt(debito.replace('$', ''.replaceAll('.', '')));
  const creditoFixed = parseInt(credito.replace('$', ''.replaceAll('.', '')));
  const disabled: boolean = (creditoFixed + debitoFixed) == 0 ? true : false;

  if(key == 'Descuadrados'){
    actions.push(
      { label: "Ver Detalle", icon: <SearchIcon fontSize="small" />, disabled:disabled, onClick: () => navigate('/contabilidad/validadorAsientos/analizarMovimientosContables/detalleDescuadrados', { state: formFilters }) },
    );
  }
  
  if(key == 'Pendientes VºBº'){
    actions.push(
      { label: "Dar VºBº	", icon: <CheckIcon fontSize="small" />, disabled:disabled, onClick: () => modalConfirmVistoBueno() },
    );
  }

  if(key == 'Enviados'){
    actions.push(
      { label: "Ver Enviados", icon: <SearchIcon fontSize="small" />, disabled:disabled, onClick: () => navigate('/contabilidad/validadorAsientos/analizarMovimientosContables/resumenEnviados', { state: formFilters }) },
    );
  }

  const handleDarVistoBueno = async () => {
    showLoader();
    const resp = await aprobarAsientosContables(formFilters!, getCurrentUsername());
    addToast({
      mostrar: true,
      titulo: resp.data.ok ? 'Éxito' : 'Error',
      tipo: resp.data.ok ? 'Success' : 'Danger',
      mensaje: resp.data.mensaje,
    });
    incrementReloadFlag();
    hideLoader();
  };

  const modalConfirmVistoBueno = () => {
    setModalConfirmacion({
      show: true,
      title: 'Dar visto bueno',
      message: '¿Está seguro que desea dar visto bueno?',
      metodo: handleDarVistoBueno,
    });
  };


  return (
    <>
      { actions.length ? (
        <>
          <ConfirmationModal
            onHide={() =>
                setModalConfirmacion({
                    ...modalConfirmacion,
                    show: false,
                })
            }
            onConfirm={modalConfirmacion.metodo}
            show={modalConfirmacion.show}
            title={modalConfirmacion.title}
            message={modalConfirmacion.message}
          />
          <ActionMenu actions={actions} />
        </>
      ) : (<></>) }
    </>
  );
};

export default AccionesAnalizador;
